<template>
  <div class="image-grid">
    <div class="image-grid__item" v-for="(item, index) in items" :key="index">
      <figure>
        <a :href="item" download title="Download this paintover">
          <img :src="item" alt="" />
        </a>
        <figcaption>
          <a :href="item" download>
            <font-awesome-icon size="sm" icon="download"></font-awesome-icon>
            Download paintover
          </a>
        </figcaption>
      </figure>
    </div>
  </div>
</template>

<script>
export default {
  name: 'image-grid',
  props: ['items'],
};
</script>

<style lang="scss" scoped>
.image-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);

  &__item {
    figure {
      margin: 0;
      flex: 1;
      height: 100%;

      img {
        object-fit: cover;
        max-width: 100%;
        vertical-align: bottom;
      }

      figcaption {
        background: color('background');
        padding: 0.5rem;
        color: color('denotive', 'info');
      }
    }
  }
}
</style>
